<template>
    <div :class="{ 'groupFields driversList': driversList.length }">
        <div v-if="driversList.length" class="groupField">
            <div class="driverHeader">
                <div class="groupFieldTitle">
                    <span>Drivers</span>
                </div>
                <div class="driversSearch">
                    <field
                        margin="5px 5px 0 0"
                        width="245px"
                        placeholder="Search"
                        @updateInput="onSearch"
                        :setInputValue="searchValue"
                        icon="search"
                        padding="10px 0"
                        is-input
                        is-search
                    ></field>
                    <field
                        margin="0 0 0 10px"
                        width="115px"
                        @updateSelect="onSelectValue($event, 'selectValue')"
                        :autocompleteValue="selectValue"
                        :items="selectList"
                        :isClearable="false"
                        is-select
                        is-round
                    ></field>
                </div>
            </div>
            <template v-for="(item, idx) in getDriversList">
                <drivers-list
                    :key="item.driver_id"
                    :item="item"
                    :idx="idx"
                    @updateInput="onInput"
                    @updateDate="onDate"
                    @updateSwitch="onSwitch"
                    @updateEldPopup="onEldPopup"
                ></drivers-list>
            </template>
        </div>
    </div>
</template>

<script>

import DriversList
from "@/components/Maintenance/Customer/CustomerForm/SecondTab/Safety/Drivers/DriversList/DriversList.vue";

export default {
	name: "Drivers",
	components: {
		DriversList
	},
	props: {
		drivers: Array,
		safety_rate_driver: [ Number, String ]
	},
	computed: {
		getDriversList() {
			const value = this.searchValue.toLowerCase();
			const filterKey = this.selectValue.filterKey;

			if (value) {
				return this.drivers.filter(item => {
					const isFilterItem = item.name.toLowerCase().includes(value);
					if (filterKey === null) {
						return isFilterItem;
					} else if (filterKey) {
						return isFilterItem && !!item.status;
					}
					return isFilterItem && !item.status;

				});
			}
			return this.drivers.filter(item => {
				if (filterKey === null) {
					return true;
				} else if (filterKey) {
					return !!item.status;
				}
				return !item.status;

			});

		}
	},
	data: () => ({
		driversList: [],
		searchValue: '',
		selectList: [
			{ id: 1, value: 'Default', filterKey: null },
			{ id: 2, value: 'Active', filterKey: true },
			{ id: 3, value: 'Not active', filterKey: false }
		],
		selectValue: { id: 1, filterKey: null }
	}),
	methods: {
		onSearch({ value }) {
			this.searchValue = value;
		},
		onSelectValue({ value }, key) {
			const { id, filterKey } = value;
			this[key] = { id, filterKey };
		},
		onEldPopup(item) {
			this.$emit('updateEldPopup', item);
		},
		onAddDispatcherItem() {
			const value = {
				name: '',
				date_start: '',
				amount: null,
				status: false
			};

			this.driversList.push(value);
			this.getData();
		},
		onInput({ value }, key, item) {
			const index = this.driversList.findIndex(({ driver_id }) => driver_id === item.driver_id);
			this.driversList[index][key] = value;
			this.getData();
		},
		onDeleteItem(idx) {
			this.driversList.splice(idx, 1);
			this.getData();
		},
		onDate(date, value) {
			const index = this.driversList.findIndex(item => item.driver_id === value.driver_id);
			this.driversList[index]['date_start'] = date;
			this.getData();
		},
		getData() {
			this.$emit('updateDriversData', this.driversList);
		},
		onSwitch({ value }, { driver_id }) {
			const index = this.driversList.findIndex(item => item.driver_id === driver_id);
			this.driversList[index]['status'] = value;
			if (value) {
				this.driversList[index]['date_start'] = new Date().toISOString().substr(0, 10);
				this.driversList[index]['amount'] = this.safety_rate_driver;
			}

			this.getData();
		}
	},
	mounted() {
		this.driversList = this.drivers || [];
	}
};
</script>

<style scoped lang="scss">
@import "Drivers";
</style>
